// extracted by mini-css-extract-plugin
module.exports = {"item_div":"LeagueTab_item_div__189k6"};